<template>
	<div class="dashfilter">
		<template v-if="isMobile && mainfilters.length > 1">
			<swiper
				@swiper="onSwiper"
				@slideChange="onSlideChange"
				:direction="'horizontal'"
				:loop="false"
				:spaceBetween="20"
				:slides-per-view="1.25"
				:centeredSlides="false"
				:freeMode="{ enabled: false, sticky: false }"
				:mousewheel="true"
			>
				<swiper-slide v-for="m in mainfilters" :key="m.key">
					<el-row class="dashfilter__main" @click="$emit('toggleMainFilter', m.key)">
						<el-col :span="24" :class="{ active: m.active }">
							{{ m.label }}
						</el-col>
					</el-row>

					<el-row class="dashfilter__sub">
						<el-col v-for="s in m.subfilters" :key="s.key" :span="24" @click="$emit('toggleSubFilter', s.key)">
							<TheToggle :active="s.active" />

							<span class="dashfilter__sub__cnt">{{ s.count }}</span>
							<span class="dashfilter__sub__lbl">{{ s.label }}</span>
						</el-col>
					</el-row>
				</swiper-slide>
			</swiper>
		</template>

		<template v-else>
			<el-row class="dashfilter__main" v-if="mainfilters.length > 1">
				<el-col
					v-for="m in mainfilters"
					:key="m.key"
					:sm="24 / mainfilters.length"
					:class="{ active: m.active }"
					@click="$emit('toggleMainFilter', m.key)"
				>
					{{ m.label }}
				</el-col>
			</el-row>

			<el-row class="dashfilter__sub">
				<el-col
					v-for="s in mainfilter_active.subfilters"
					:sm="24 / mainfilter_active.subfilters.length"
					:key="s.key"
					@click="$emit('toggleSubFilter', s.key)"
				>
					<TheToggle :active="s.active" />

					<span class="dashfilter__sub__cnt">{{ s.count }}</span>
					<span class="dashfilter__sub__lbl">{{ s.label }}</span>
				</el-col>
			</el-row>
		</template>
	</div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import TheToggle from './TheToggle.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { useStore } from '../store';

export interface SubfilterItem {
	key: any;
	active: boolean;
	count?: number;
	label: string;
}

export interface FilterItem {
	key: string;
	label: string;
	active: boolean;
	subfilters: SubfilterItem[];
}

export default defineComponent({
	name: 'DashFilter',
	data() {
		return {};
	},
	props: {
		mainfilters: {
			type: Object as () => FilterItem[],
			required: true,
		},
	},
	emits: ['toggleMainFilter', 'toggleSubFilter'],
	components: {
		TheToggle,
		Swiper,
		SwiperSlide,
	},
	setup() {
		const store = useStore();
		const isMobile = computed(() => store.state.isMobile);

		return {
			isMobile,
		};
	},
	methods: {
		onSlideChange(e) {
			let newMainFilter = this.mainfilters[e.activeIndex];
			this.$emit('toggleMainFilter', newMainFilter.key);
		},
	},
	computed: {
		mainfilter_active() {
			return this.mainfilters.find((m) => m.active) || this.mainfilters[0];
		},
	},
});
</script>
